import { pubText, pubPath } from "../i18n/publicTranslation";
import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import SEO from './SEO';
import noDataAnimation from '../lottie/no-data.json';
import { getLibraryEmptyStateAnimationSx } from './common/LibraryEmptyState';
import { lottieContentStyle, lottieRendererSettings } from './common/lottieSizing';
import { primaryActionButtonSx } from './common/StoryFormControls';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const goBack = () => {
    if (window.history.state?.idx > 0) navigate(pubPath(-1));
    else navigate(pubPath('/'), { replace: true });
  };

  return (
    <Container component="main" aria-labelledby="not-found-heading" maxWidth="sm" sx={{
      pt: { xs: 12, sm: 14 }, pb: { xs: 6, sm: 8 }, minHeight: '100svh',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center',
    }}>
      <SEO title={pubText("Page not found | Fable")} description={pubText(
        "This page could not be found. Explore Fable stories or return to the homepage."
      )} noindex statusCode={404} />
      <Box aria-hidden="true" sx={getLibraryEmptyStateAnimationSx(noDataAnimation)}>
        <Lottie animationData={noDataAnimation} loop autoplay style={lottieContentStyle} rendererSettings={lottieRendererSettings} />
      </Box>
      <Typography id="not-found-heading" component="h1" sx={{ color: '#fff', fontSize: { xs: 24, sm: 28 }, fontWeight: 900, mb: 1.5 }}>{pubText("Page not found")}</Typography>
      <Typography sx={{ color: '#A4A5B0', fontSize: { xs: 16, sm: 18 }, lineHeight: 1.55, maxWidth: 480, mb: 3 }}>{pubText("This link may have changed, or the page is no longer available.")}</Typography>
      <Button onClick={goBack} variant="contained" disableElevation sx={primaryActionButtonSx}>{pubText("Go back")}</Button>
    </Container>
  );
};

export default NotFoundPage;
